import { KEEP_ALIVE_OBJECT } from '@/common/constants/ConstCode';
import store from '@/store';
import { isEmpty } from '@/common/utils/Util';
import router from '@/router';
import { showTextModal } from '@/common/utils/ModalState';
import { toastAlert } from '@/common/utils/module/ToastSupport';

export default [
  {
    path: '/more',
    component: () => import('@/views/more/'),
    meta: {
      // 260611 typeC 리뉴얼: 마이페이지는 자체 헤더(제목 '마이'+알림벨)를 렌더하므로 전역 헤더 OFF.
      isHeader: false,
      isNav: true,
      titleName: '마이',
      isBell: true,
      isHome: true,
      isSetting: true,
      isFooter: true
    },
    beforeEnter: () => {
      const user = store.getters['user/getUserData'];
      if (isEmpty(user.userNo)) {
        store.commit('layout/setLoginMovePath', '/more'); // 260821 — 로그인 후 마이 탭 복귀(복귀 경로 누락분)
        router.push('/signin');
      }
    }
  },
  {
    path: '/more/user/update',
    component: () => import('@/views/more/user/update.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isHome: true,
      isNav: false,
      titleName: '회원정보 수정하기'
    }
  },
  {
    path: '/more/user/update/password',
    component: () => import('@/views/more/user/UpdatePassword.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      isHome: true,
      titleName: '비밀번호 변경하기'
    }
  },
  {
    path: '/more/setting',
    component: () => import('@/views/more/setting/index.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      titleName: '설정'
    }
  },
  {
    path: '/more/notification',
    component: () => import('@/views/more/notification/index.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      titleName: '알림'
    }
  },
  {
    path: '/more/notification/:notificationNo',
    component: () => import('@/views/more/notification/detail.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      titleName: '알림 상세보기'
    }
  },
  // 260919 통합 통계로 통일 — 옛 select?target=stats 는 ① 브랜치에서 사라진다(마이 '통계' 타일·햄버거가 이 경로를 씀).
  {
    path: '/more/signboard-stats',
    redirect: '/more/stats'
  },
  // 260919 통합 통계(간판 축 + 현판 축). 비로그인은 안내 모달 후 /signin(복귀 경로 저장). 플래그 statsPageEnabled=false 면 페이지가 기존 SignboardStats 로 위임.
  {
    path: '/more/stats',
    component: () => import('@/views/more/stats/StatsPage.vue'),
    meta: { isHeader: false, isBack: false, isNav: true, isHome: true, titleName: '통계' },
    beforeEnter: async (to) => {
      const user = store.getters['user/getUserData'];
      if (isEmpty(user?.userNo)) {
        store.commit('layout/setLoginMovePath', to.fullPath);
        showTextModal('로그인 후 이용가능합니다.', '확인');
        return '/signin';
      }
    }
  },
  {
    path: '/more/memorial',
    component: () => import('@/views/more/memorial/index.vue'),
    meta: {
      isHeader: false,
      isBack: true,
      isHome: true,
      isNav: false,
      titleName: '추모관 관리'
    }
  },
  {
    path: '/more/andersen',
    component: () => import('@/views/more/andersen/MyAndersenList.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isHome: true,
      isNav: false,
      titleName: '안데르센관 관리'
    }
  },
  {
    path: '/more/form/memorial/:memorialNo',
    component: () => import('@/views/memorial/register/step2.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isHome: true,
      isNav: false,
      subName: '추모관 수정하기',
      expression: KEEP_ALIVE_OBJECT.MEMORIAL_REGISTER.expression
    }
  },
  {
    path: '/more/form/memorial/anniversary/:memorialNo',
    component: () => import('@/views/memorial/register/step3.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isHome: true,
      isNav: false,
      subName: '추모관 수정하기',
      expression: KEEP_ALIVE_OBJECT.MEMORIAL_REGISTER.expression
    }
  },

  {
    path: '/more/form/memorial/background/:memorialNo',
    component: () => import('@/views/memorial/register/step4.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isHome: true,
      isNav: false,
      subName: '추모관 수정하기',
      expression: KEEP_ALIVE_OBJECT.MEMORIAL_REGISTER.expression
    }
  },
  {
    path: '/more/funeral',
    component: () => import('@/views/more/funeral/index.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isHome: true,
      isNav: false,
      titleName: '온라인 장례식장 관리'
    }
  },
  {
    path: '/more/funeral/form/:funeralNo',
    component: () => import('@/views/more/funeral/update.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isHome: true,
      isNav: false,
      titleName: '온라인 장례식장 수정하기'
    }
  },
  {
    path: '/more/announcement',
    component: () => import('@/views/more/announcement/index.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isHome: true,
      isNav: false,
      titleName: '온라인 부고장 관리'
    }
  },
  {
    path: '/more/announcement/form/:announcementNo',
    component: () => import('@/views/more/announcement/update.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      titleName: '온라인 부고장 수정하기'
    }
  },

  {
    path: '/more/payment',
    component: () => import('@/views/more/payment/index.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isHome: true,
      isNav: false,
      titleName: '결제내역'
    }
  },
  {
    path: '/more/item/buy',
    component: () => import('@/views/more/item/Shop.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      titleName: '상품구매'
    }
  },
  // 260710 대표 컨펌: 설치 신청 폼(/more/qr-install) 폐기 — 진입점 전부 스마트스토어 직연결(QR_SMARTSTORE_URL)
  // 260710 정품등록(디지털 보증서) — 시리얼 등록 → 보증 2년+AI 제작권(전단지/명함 선택)+교체 50%
  {
    path: '/more/qr-genuine',
    component: () => import('@/views/more/qr/GenuineRegister.vue'),
    // 260803 시안(main_typeC_02): 헤더를 초록 히어로 안에 그린다(제목+알림+햄버거, 뒤로가기 없음) → isHeader:false.
    //   isNav도 false→true. 하단 탭 '정품등록'으로 들어오는 화면인데 도착하면 탭바가 사라져 동선이 끊겼다.
    meta: {
      isHeader: false,
      isBack: false,
      isNav: true,
      isHome: true,
      titleName: '정품등록 · 디지털 보증서'
    }
  },
  // 260819 내 현판 허브 — 보유 현판 카드 + PIN 없는 메뉴판/관리 진입(manage-ticket). 마이 '현판' 타일의 목적지.
  {
    path: '/more/qr-hub',
    component: () => import('@/views/more/qr/QrHubPage.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      titleName: '내 QR 현판 관리' // 260923 대표 회의: 홈 버튼 라벨과 같게('현판' 앞엔 QR)
    }
  },
  // 260810 정품등록 활성화(기본정보 → 즉시 개통) — 시트가 아니라 페이지(대표 지적 대비). ?code= 필수.
  {
    path: '/more/qr-genuine/activate',
    component: () => import('@/views/more/qr/GenuineActivate.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      titleName: 'QR현판 정보 입력'
    }
  },
  // 260812 정품인증 — 시트가 아니라 페이지(유저: "시트 다 페이지로 바꿔"). 방법선택 → 스캔/코드 입력.
  //   인증이 끝나면 완료 화면 없이 다음 할 일로 바로 보낸다(개통 / 사업자등록 / 내 현판).
  {
    path: '/more/qr-genuine/verify',
    component: () => import('@/views/more/qr/GenuineVerify.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      titleName: '정품 등록'
    }
  },
  // 260812 사업자 등록 — 시트가 아니라 페이지(유저: "백퍼 대표님이 불편하다 할 거야"). ?code= 필수.
  //   activate와 같은 계약: 로그인 게이트(쿼리 포함 복귀)·소유 확인·이미 연결이면 내 현판으로 replace.
  {
    path: '/more/qr-genuine/business',
    component: () => import('@/views/more/qr/GenuineBizRegister.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      titleName: '사업자 등록'
    }
  },
  // 260714 주차 편의 오브제 등록 — 주차판 QR + 연락처/메시지.
  // 261019 주차판 홈 단독 화면 — 차량 이동 푸시·등록 완료가 여기로 온다(사장님도 판이 있으면 연다).
  //   로그인 필수 + 스위치 가드(진입 때 번들을 새로 받는다, rule 55-2·3). 꺼졌으면 지금 있는 '내 주차판'으로.
  {
    path: '/parking',
    component: () => import('@/views/landing/parking/ParkingHomePage.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: true,
      isHome: true,
      titleName: '내 등록차량보기'
    },
    beforeEnter: async to => {
      const user = store.getters['user/getUserData'];
      if (isEmpty(user?.userNo)) {
        store.commit('layout/setLoginMovePath', to.fullPath);
        toastAlert('로그인 후 내 차 화면을 볼 수 있습니다.', 3000, 'info');
        return '/signin';
      }
      await store.dispatch('common/fetchFeatureFlags', { force: true });
      if (store.getters['common/getFeatureFlags']?.parkingHomeEnabled !== true) return '/more/qr-parking';
      return true;
    }
  },
  // 261023 차량 관리(주유비·엔진오일) — 주차판 홈 내 차 카드의 [차량 관리] 버튼과 엔진오일 알림(&v=oil)이 여기로 온다.
  //   ①첫 화면 ②주유 기록(v=fuel) ③이번 달(v=month) ④엔진오일(v=oil) = 쿼리 v 한 칸씩(뒤로가기 = 앞 화면).
  //   가드는 /parking 과 같은 방식(로그인 + 진입 때 번들을 새로 받는다, rule 55-2·3). 꺼졌으면 주차판 홈으로.
  {
    path: '/parking/care',
    component: () => import('@/views/landing/parking/CarCarePage.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      isHome: true,
      titleName: '차량 관리'
    },
    beforeEnter: async to => {
      const user = store.getters['user/getUserData'];
      if (isEmpty(user?.userNo)) {
        store.commit('layout/setLoginMovePath', to.fullPath);
        toastAlert('로그인 후 차량 관리를 볼 수 있습니다.', 3000, 'info');
        return '/signin';
      }
      await store.dispatch('common/fetchFeatureFlags', { force: true });
      if (store.getters['common/getFeatureFlags']?.carCareEnabled !== true) return '/parking';
      return true;
    }
  },
  // 261027 에이전트(대리점) 현황(회의록 #7 7번) — 로그인 + 스위치 가드(/parking 과 같은 방식, rule 55-2·3). 꺼졌으면 마이페이지로.
  {
    path: '/more/agent',
    component: () => import('@/views/more/agent/AgentHome.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: true,
      titleName: '에이전트'
    },
    beforeEnter: async to => {
      const user = store.getters['user/getUserData'];
      if (isEmpty(user?.userNo)) {
        store.commit('layout/setLoginMovePath', to.fullPath);
        toastAlert('로그인 후 에이전트 현황을 볼 수 있습니다.', 3000, 'info');
        return '/signin';
      }
      await store.dispatch('common/fetchFeatureFlags', { force: true });
      if (store.getters['common/getFeatureFlags']?.agentEnabled !== true) return '/more';
      return true;
    }
  },
  // 261001 대표 회의: 사은품 주차판 = 회원 모집 → 등록은 로그인 필수(유저 확정). 복귀 경로 저장 후 /signin(통계·비즈매칭과 같은 방식).
  {
    path: '/more/qr-parking',
    component: () => import('@/views/more/qr/QrParkingRegister.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      isHome: true,
      titleName: '주차 안심연락 등록'
    },
    beforeEnter: to => {
      const user = store.getters['user/getUserData'];
      if (isEmpty(user?.userNo)) {
        store.commit('layout/setLoginMovePath', to.fullPath);
        // 화면을 옮기며 알리므로 토스트(모달은 이동하며 닫혀 안 보인다 — 비즈매칭 가드와 같은 이유, 261001 E2E 실측)
        toastAlert('로그인 후 주차판을 등록할 수 있습니다.', 3000, 'info');
        return '/signin';
      }
      return true;
    }
  },
  // 260714 강아지 네임택 등록 — 시리얼+휴대폰 인증+관리비번(계정 없이), 펫 이름·특이사항·사진
  {
    path: '/more/qr-pet',
    component: () => import('@/views/more/qr/QrPetRegister.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      isHome: true,
      titleName: '반려동물 목걸이 인식표 등록'
    }
  },
  // 260716 어르신 안심태그 등록 — 시리얼 폐지, QR code + 휴대폰 인증 + 관리비번(계정 없이). 펫 네임택 틀 복제
  {
    path: '/more/qr-silver',
    component: () => import('@/views/more/qr/QrDementiaRegister.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      isHome: true,
      titleName: '어르신 안심태그 등록'
    }
  },
  // 260710 프리미엄관(대표 구상 재작업) — 오프라인 디지털 간판 설치 인증 업체 리스트 + 혜택 안내.
  // ⚠️ 경로를 /more/premium-hall로 분리: /more/premium은 구 '내 프리미엄 포인트' 라우트(아래 470행대)와 중복 충돌이었음.
  {
    path: '/more/premium-hall',
    component: () => import('@/views/more/qr/PremiumHall.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      isHome: true,
      titleName: '프리미엄관'
    }
  },
  {
    path: '/more/setting/family',
    component: () => import('@/views/more/setting/family/index.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      titleName: '가족관리'
    }
  },
  {
    path: '/more/setting/family/search',
    component: () => import('@/views/more/setting/family/search.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      titleName: '가족검색'
    }
  },
  {
    path: '/more/setting/family/search/:familyCode',
    component: () => import('@/views/more/setting/family/search.vue'),
    meta: {
      isHeader: true,
      isBack: false,
      isNav: false,
      titleName: '가족검색'
    }
  },
  {
    path: '/more/setting/family/register',
    component: () => import('@/views/more/setting/family/register.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      titleName: '가족생성'
    }
  },
  {
    path: '/more/item',
    component: () => import('@/views/more/item/MyItemList.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isHome: true,
      isNav: false,
      titleName: '내 상품'
    }
  },
  {
    path: '/more/church',
    component: () => import('@/views/more/church/index.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      titleName: '교회,기독교 묘원 및 단체 소속 신청'
    }
  },
  {
    path: '/more/death',
    component: () => import('@/views/more/death/register.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      titleName: '사망 확인서 제출'
    }
  },
  {
    path: '/more/notice',
    component: () => import('@/views/more/notice/index.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      titleName: '공지사항'
    }
  },
  {
    path: '/more/notice/:noticeNo',
    component: () => import('@/views/more/notice/detail.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      isHome: true,
      titleName: '공지사항'
    }
  },
  {
    path: '/more/inquiry',
    component: () => import('@/views/more/inquiry/index.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isHome: true,
      isNav: false,
      titleName: '고객센터'
    }
  },
  {
    path: '/more/inquiry/:inquiryNo',
    component: () => import('@/views/more/inquiry/detail.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isHome: true,
      isNav: false,
      titleName: '문의하기'
    }
  },
  {
    path: '/more/inquiry/register',
    component: () => import('@/views/more/inquiry/register.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isHome: true,
      isNav: false,
      titleName: '문의하기'
    }
  },
  {
    path: '/more/inquiry/withdraw/register',
    component: () => import('@/views/more/inquiry/withdraw/register.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      titleName: '탈퇴 문의하기'
    }
  },
  {
    path: '/more/faq',
    component: () => import('@/views/more/faq/index.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      titleName: '자주 묻는 질문'
    }
  },
  {
    path: '/more/faq/:faqNo',
    component: () => import('@/views/more/faq/detail.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      titleName: '자주 묻는 질문'
    }
  },
  {
    path: '/more/law',
    component: () => import('@/views/more/law/index.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      titleName: '법률검토'
    }
  },
  {
    path: '/more/law/register/:lawyerNo',
    component: () => import('@/views/more/law/register.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      titleName: '법률검토 신청하기'
    }
  },

  {
    path: '/more/like/pray',
    component: () => import('@/views/more/like/LikePrayList.vue'),
    meta: {
      isHeader: true,
      isNav: true,
      isBack: true,
      isHome: true,
      // subName: '좋아요 기도 모아보기',
      titleName: '좋아요 기도 모아보기'
      // expression: KEEP_ALIVE_OBJECT.WELL_DYING.expression
    }
  },
  {
    path: '/more/like/business',
    component: () => import('@/views/more/like/LikeBusinessList.vue'),
    meta: {
      isHeader: true,
      isNav: true,
      isBack: true,
      isHome: true,
      // 260612 typeC 리뉴얼 — 헤더 타이틀 '좋아요' (우측 홈·햄버거는 260421 회의 전 페이지 공통이라 유지)
      titleName: '좋아요'
    }
  },
  // 260428: 마케팅 알림 구독한 사업장 목록
  {
    path: '/more/subscribe/business',
    component: () => import('@/views/more/subscribe/SubscribedBusinessList.vue'),
    meta: {
      isHeader: true,
      isNav: true,
      isBack: true,
      isHome: true,
      titleName: '구독'
    }
  },
  {
    path: '/more/user/withdraw',
    component: () => import('@/views/more/user/Withdraw.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      isHome: true,
      titleName: '회원탈퇴'
      // expression: KEEP_ALIVE_OBJECT.WELL_DYING.expression
    }
  },
  {
    path: '/more/premium',
    component: () => import('@/views/more/premium/index.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      titleName: '내 프리미엄 포인트',
      isHome: true
    }
  },
  // 260424 오후회의2: 기존 회원도 마이페이지에서 관심 업종 편집 가능
  {
    path: '/more/interest-category',
    component: () => import('@/views/more/InterestCategoryEdit.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      isHome: true,
      titleName: '관심 업종 고르기'
    }
  },
  // 260428 5월오픈 4번: 알림 카테고리 6종 + quiet hours + 채널 광고 동의
  {
    path: '/more/notification-settings',
    component: () => import('@/views/more/notification/Settings.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      isHome: true,
      titleName: '알림 설정'
    }
  }
];
